import { render, staticRenderFns } from "./BatchRefunds.vue?vue&type=template&id=5128fb39&"
import script from "./BatchRefunds.vue?vue&type=script&lang=js&"
export * from "./BatchRefunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports